const DB_NAME = "screen-recorder-db";
const STORE_NAME = "chunks";

export function openDB() {
  return new Promise((resolve, reject) => {

    const request = indexedDB.open(DB_NAME, 1);

    request.onupgradeneeded = () => {
      const db = request.result;

      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, {
          autoIncrement: true,
        });
      }
    };

    request.onsuccess = () => resolve(request.result);

    request.onerror = () => reject(request.error);
  });
}

/* -------------------------------------------------- */
/* saveChunk */
/* -------------------------------------------------- */
export async function saveChunk(chunk) {

  const db = await openDB();

  return new Promise((resolve, reject) => {

    const tx = db.transaction(STORE_NAME, "readwrite");

    tx.objectStore(STORE_NAME).add(chunk);

    tx.oncomplete = resolve;

    tx.onerror = () => reject(tx.error);
  });
}

/* -------------------------------------------------- */
/* getAllChunks */
/* -------------------------------------------------- */
export async function getAllChunks() {

  const db = await openDB();

  return new Promise((resolve, reject) => {

    const tx = db.transaction(STORE_NAME, "readonly");

    const request = tx.objectStore(STORE_NAME).getAll();

    request.onsuccess = () => resolve(request.result);

    request.onerror = () => reject(request.error);
  });
}

/* -------------------------------------------------- */
/* clearChunks */
/* -------------------------------------------------- */
export async function clearChunks() {

  const db = await openDB();

  return new Promise((resolve, reject) => {

    const tx = db.transaction(STORE_NAME, "readwrite");

    const request = tx.objectStore(STORE_NAME).clear();

    request.onsuccess = resolve;

    request.onerror = () => reject(request.error);
  });
}